<div class="confirm-plan-container">
	<ng-container *ngIf="!modelpopup.showConfirmBox;else showConfirmContainer">
		<div class="confirm-plan-header">
			<img src="assets/images/new-set/confirm-dark.svg" alt="">
			<div class="header-details">
				<h4 class="title">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_CONFIRM_PLAN'| translate}}</h4>
				<p class="subtitle">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_PLAN_TEXT'| translate}}</p>
			</div>
		</div>
		<div class="plan-details-container" >
			<!-- card based class name
			standard-card
			professional-card
			enterprise-card -->
			<div class="details-header standard-card" [ngClass]="cssClass[modelpopup.packageId]" >
				<h4 class="plan-title"><img [src]="packageImage[modelpopup.packageId]" alt="">{{modelpopup.subscriptionName}}</h4>
				<ul class="detail-list">
					<li>
						<span class="label">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_ORG'| translate}}</span>
						<span class="value">{{modelpopup.organizationName}}</span>
					</li>
					<li>
						<span class="label">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_DURATION'| translate}}</span>
						<span class="value">{{modelpopup.startDate | date :'d MMM Y'}} - {{modelpopup.lastDate | date :'d MMM Y'}}</span>
					</li>
				</ul>
			</div>
			<!-- <div class="details-body">
				<ul class="price-list">
					<li>
						<p>{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_PACKAGE_PRICE'| translate}}</p>
						<p>{{modelpopup.packagePrice|
                            currency: 'USD':
                            'symbol':'1.2-2'}}</p>
					</li>
					<li *ngIf="modelpopup.extraUser != 0">
						<p>{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_MSG_EXTRA_USER'| translate}} ({{modelpopup.extraUser}} {{'CONFIRM_POPUP_SUBSCRIPTION.LBL_USER'| translate}})</p>
						<p>{{modelpopup.userPrice|
                            currency: 'USD':
                            'symbol':'1.2-2'}}</p>
					</li>
					<li class="total-price">
						<p>{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_TOTAL_PRICE'| translate}}</p>
						<p>{{modelpopup.totalPrice|
                            currency: 'USD':
                            'symbol':'1.2-2'}}</p>
					</li>
				</ul>
			</div> -->
		</div>
		<div class="text-right mt-4">
			<button class="tertiary-cta big" (click)="close()">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_CANCEL'| translate}}</button>
			<button class="primary-cta big ml-2" (click)="confirmPlan()">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_CONFIRM'| translate}}</button>
		</div>
	</ng-container>

	<ng-template #showConfirmContainer>
		<div class="confirmation-success-container">
			<img src="assets/images/new-set/confirm-green-big.svg" alt="">
			<h4 class="title">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_PLAN'| translate}} {{modelpopup.subscriptionName}} {{'CONFIRM_POPUP_SUBSCRIPTION.LBL_SUCCESS'| translate}}</h4>
			<p class="subtitle">{{'CONFIRM_POPUP_SUBSCRIPTION.LBL_PLAN'| translate}} {{modelpopup.subscriptionName}} {{'CONFIRM_POPUP_SUBSCRIPTION.LBL_SUC_PURCHASE'| translate}} {{modelpopup.organizationName}}</p>
			<button class="primary-cta big" (click)="success()">Done</button>
		</div>
	</ng-template>
</div>